import { render, staticRenderFns } from "./abroad-sitc.vue?vue&type=template&id=30675f9a&scoped=true&"
import script from "./abroad-sitc.vue?vue&type=script&lang=js&"
export * from "./abroad-sitc.vue?vue&type=script&lang=js&"
import style0 from "./abroad-sitc.vue?vue&type=style&index=0&id=30675f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30675f9a",
  null
  
)

export default component.exports